import React from 'react';
import ProdReviewList from 'src/components/detail/prodReview/ReviewList';

const ReviewList = () => {
  return <ProdReviewList />;
};

export default ReviewList;
